<div class="container align-items-center justify-content-center">
  <div class="row hero align-items-center">
    <div class="col-md-6">
      <div class="hero-content">
        <p class="eyebrow">Built for medical &amp; professional societies</p>
        <h1 class="headline mt-primary-text">Membership software for medical &amp; professional societies</h1>
        <p class="subheadline mt-primary-text">Renewals, annual meetings, CME events, dues, applications, and member directories in one branded portal—so your society runs on one system instead of spreadsheets and disconnected tools.</p>
        <div class="cta-buttons">
          <button mat-flat-button color="primary" routerLink="/register-organization">Start free trial</button>
          <a mat-stroked-button color="primary" routerLink="/" fragment="see-how-it-works">See how it works</a>
        </div>
        <p class="quick-start-note">90-day free trial for organizations with up to 50 active members. Card required at signup; you won't be charged today.</p>
      </div>
    </div>
    <div class="col-md-6 d-flex align-items-center hero-visual mt-4 mt-lg-0">
      <div class="hero-image-container">
        <img 
          src="/img/hero.webp" 
          alt="MemberTrace Dashboard" 
          class="hero-image" 
          fetchpriority="high"
          width="600"
          height="500" />
      </div>
    </div>
    <div class="col-12">
      <app-client-logo-strip
        class="d-block text-center mt-5"
        title="Trusted by organizations like these"
        variant="wrap"
        wrapPreset="hero" />
    </div>
  </div>
</div>
